import React, { Component, Suspense } from "react";
import axios from "axios";
import _ from "lodash";
import { Button } from "reactstrap";
import { Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { DatePicker } from "antd";
import moment from "moment";
import { Services } from "../../../repositories/clients/Services";
import FormFiltros from "./model/form";
import FormFiltrosDispach from "./model/formDispach";
import queryString from "query-string";
import "./styles.scss";
import "./Components/styles/cards.scss";
import { withNamespaces } from "react-i18next";

import Receive from "./Tabs/Receive";

const Map = React.lazy(() => import("../Components//Maps/map"));

const { RangePicker } = DatePicker;

class InTransit extends Component {
  state = {
    isMovil: false,
    searching: "0",
    rolId: this.props._rolId,
    userId: this.props._user,
    rowid: "",
    extraElement: false,
    respladoCatalogCombo: {},

    map: (
      <Suspense fallback={<div>Loading...</div>}>
        <Map
          polylineData={[]}
          heidIcon={20}
          disableDefaultUI={true}
          // style={{ maxHeight: "300px" }}
          marker={[]}
          visible={true}
          type={"polyline"}
          data={[]}
          dataDrawer={""}
          // zoom={3}
        />
      </Suspense>
    ),
    // clientesSelect: clientSave.getAuthentication('client'),
    clientesSelect: this.props.clients
      ? JSON.stringify(this.props.clients)
      : "[0]",
    activePage: 1,
    limit: 10,
    catalogCombo: [],
    paramsxml: {},
    numberPage: 1,
    totalPages: 1,
    pages: 0,
    numberPageOrder: 1,
    activePageOrder: 1,
    totalPagesOrder: 1,
    searchOrder: "",
    isSearchsearchOrder: false,
    excelOrderLoading: false,
    limitOrder: 10,
    pagesOrder: 0,
    totalPagesExt: 1,
    search: "",
    isSearch: false,
    excelShipmentLoading: false,
    totalCard: [],
    dataDrawer: "",
    visible: false,
    selected: "",
    polyline: [],
    data: [],
    dataTable: [],
    // dataMap: mapJson.dataMap,
    dataAux: [],
    activePageAux: 1,
    dataOut: [],
    labelSelected: "",
    loading: true,
    graphs: [],
    markers: [],
    dataMap: [],
    donutChart: [],
    extraFilter: "",
    priorityChecked: false,

    /*
    "Status":null,
         "rowNum":1,
         "Progress":0,
         "Received":null,
         "Released":null,
         "StatusId":null,
         "Consignee":"Onboard Logistics USA Inc",
         "Consignor":"Onboard Logistics USA Inc",
         "Warehouse":"MIA",
         "ConsigneeId":237234,
         "ConsignorId":237234,
         "Destination":null,
         "Observation":"1Z6658080334115957",
         "ReferenceNo":"119133512",
         "TransactionNo":"RC00128110",
         "TransportModeId":null
         */
    config: [
      {
        title: this.props.t("status"),
        idExcel: "Status",
        xls: true,
        header: { link: false, hide: true, icon: false },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          hide: true,
        },
        id: "null",
        className: "hidden",
      },
      {
        title: "",
        xls: false,
        first: true,
        foot: { show: false, style: { fontSize: "12px", fontWeight: "bold" } },
        header: { link: false, hide: true, icon: false },
        data: { link: false, progress: false, icon: false, status: false },
        id: "rowNum",
        link: "/intransit",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("receive_rcn_no"),
        xls: true,
        foot: {
          show: false,
          style: { fontSize: "12px", fontWeight: "bold", color: "green" },
        },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          custom: true,
        },
        header: { link: false, validateEvents: false },
        id: "TransactionNo",
        custom: (value) => (
          <div class="mb-mail-from">
            <center>
              <Link className="linkDetail" to={"/intransit/"}>
                {value.TransactionNo}
              </Link>
            </center>
          </div>
        ),
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },

      {
        title: this.props.t("receive_consignor"),
        xls: true,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        colorLogo: "#643296c2",
        id: "Consignor",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 25,
      },
      {
        title: this.props.t("receive_consignee"),
        xls: true,
        colorLogo: "#643296c2",
        id: "Consignee",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 25,
      },
      {
        title: this.props.t("dispatch_warehouse"),
        xls: true,
        id: "Warehouse",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
        limitText: 15,
      },
      {
        title: this.props.t("dispatch_rcn_reference_no"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        id: "ReferenceNo",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
      },

      {
        title: this.props.t("dispatch_observation"),
        xls: true,
        id: "Observation",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("dispatch_received"),
        xls: true,
        id: "Received",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("dispatch_released"),
        xls: true,
        id: "Released",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
    ],

    configDispach: [
      {
        title: this.props.t("status"),
        idExcel: "Status",
        xls: true,
        header: { link: false, hide: true, icon: false },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          hide: true,
        },
        id: "null",
        className: "hidden",
      },
      {
        title: "",
        xls: false,
        first: true,
        foot: { show: false, style: { fontSize: "12px", fontWeight: "bold" } },
        header: { link: false, hide: true, icon: false },
        data: { link: false, progress: false, icon: false, status: false },
        id: "ShipmentId",
        link: "/",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("receive_dcn_no"),
        xls: true,
        foot: {
          show: false,
          style: { fontSize: "12px", fontWeight: "bold", color: "green" },
        },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          custom: true,
        },
        header: { link: false, validateEvents: false },
        id: "ShipmentNumber",
        custom: (value) => (
          <div class="mb-mail-from">
            <center>
              <Link
                className="linkDetail"
                to={"/shipmentsDetail/" + value.ShipmentId}
              >
                {value.ShipmentNumber}
              </Link>
            </center>
          </div>
        ),
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },

      {
        title: this.props.t("receive_consignor"),
        xls: true,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        colorLogo: "#643296c2",
        id: "CustomerName",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 30,
      },
      {
        title: this.props.t("receive_consignee"),
        xls: true,
        colorLogo: "#643296c2",
        id: "ShipperName",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 25,
      },
      {
        title: this.props.t("receive_destination"),
        xls: true,
        id: "ConsigneeName",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
        limitText: 15,
      },
      {
        title: this.props.t("receive_dcn_reference_no"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        id: "CustomertRef",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
      },

      {
        title: this.props.t("receive_transport"),
        xls: true,
        id: "Containers",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("dispatch"),
        xls: true,
        id: "dispatch",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
    ],

    advancedSearch2: FormFiltros,
    advancedSearch: [],
    advancedObj: [],
    advancedOrderObj: [],
    url: "",
    totalShipments: "",
    advancedSearchDispach: FormFiltrosDispach,
  };

  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMovil: isMobileDevice,
    });
    let objSearch = queryString.parse(this.props.location.search);
    let searching = objSearch.searching ? objSearch.searching : "0";

    this.setState({ searching }, () => {
      //this.getListShipments();
      //this.getCatalogs();
      this.getMapShipments();
      //this.resetAdvance();
    });
    window.addEventListener("resize", () => {
      let newGraphs = this.state.graphs;
      newGraphs.map((e) => {
        e.width = this.calculateWidth();
        return e;
      });
      this.setState({ graphs: newGraphs });
    });
  };

  currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });
    return formatter.format(value);
  }

  getMapShipments = () => {
    let data = {
      client: this.state.clientesSelect,
      userId: this.state.userId,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.WAREHOUSE.path}intransit/MapsShipments`, data)
      .then((success) => {
        let markers = [];
        let polylineData = [];

        success.data.data.map((e, index) => {
          if (e.latitude && e.longitude) {
            if (e.latitude && e.longitude) {
              let obj = {
                anchorX: 20,
                anchorY: 20,
                key: `${index}From`,
                title: this.props.t("origin"),
                name: e.warehouse,
                data: e,
                position: {
                  lat: e.latitude,
                  lng: e.longitude,
                },
                icon: {
                  url: "https://magiclog.blob.core.windows.net/onboardpic/warehouse-solid-blue.svg",
                  // e.TransportMode === "AIR"

                  //   ? "https://fsposeidon.blob.core.windows.net/seacargopic/Transporte-Aereo-Mapa[1].png"
                  //   : e.TransportMode === "SEA"
                  //     ? "https://magiclog.blob.core.windows.net/onboardpic/sea_shipment.png"
                  //     : "https://fsposeidon.blob.core.windows.net/seacargopic/Transporte-Terrestre-Mapa[1].png",
                },
              };

              let position = {
                lat: Number(e.latitude),
                lng: Number(e.longitude),
              };
              polylineData.push(position);
              markers.push(obj);
            }
          }
          return e;
        });

        this.setState(
          {
            markers: markers,
            //dataMap: polylineData,
            //polyline: polylineData,
            // fullLoader: true,
            // totalCard: totalCard,
          },
          () => {
            this.setState({
              map: (
                <Suspense fallback={<div>Loading...</div>}>
                  <Map
                    polylineData={this.state.polylineData}
                    heidIcon={20}
                    style={{ maxHeight: "300px" }}
                    marker={this.state.markers}
                    visible={true}
                    type={"polyline"}
                    data={this.state.polylineData}
                    dataDrawer={this.state.dataDrawer}
                    zoom={3}
                  />
                </Suspense>
              ),
            });
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  calculateWidth = () => {
    if (window.innerWidth >= 1756) {
      return (window.innerWidth / 4.8).toString();
    } else {
      return (window.innerWidth / 5.5).toString();
    }
  };

  handleSelectedFile = (value) => {
    try {
      let out = this.searchSelected(value);
      this.setState({
        selected: value,
        data: [out],
        dataOut: [out],
        labelSelected: value,
        activePage: 1,
        totalPages: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  searchSelected = (ID) => {
    let { dataAux } = this.state;
    let FOUND = dataAux.find((o) => o.id === ID);
    return FOUND;
  };
  toggleDrawerMap = (data) => (evt) => {
    if (evt) evt.preventDefault();

    this.handleSelectedFile(data.id);
    this.setState({ visible: true, dataDrawer: data }, () => {
      this.setState({
        map: (
          <Suspense fallback={<div>Loading...</div>}>
            <Map
              polylineData={this.state.polylineData}
              heidIcon={20}
              style={{ maxHeight: "300px" }}
              marker={this.state.markers}
              visible={true}
              type={"polylineDrawer"}
              data={this.state.polylineData}
              dataDrawer={this.state.dataDrawer}
              zoom={3}
            />
          </Suspense>
        ),
      });
    });
  };

  redirectTo = (id) => (evt) => {
    // evt.preventDefault();
    // this.props.history.push('/tracking/'+id)
  };

  resetTableCards = (evt) => {
    evt.preventDefault();
    let { dataAux, totalPagesExt, activePageAux } = this.state;
    this.setState(
      {
        data: _.cloneDeep(dataAux),
        dataOut: _.cloneDeep(dataAux),
        labelSelected: "",
        activePage: activePageAux,
        totalPages: totalPagesExt,
        dataDrawer: "",
      },
      () => {
        this.setState({
          map: (
            <Suspense fallback={<div>Loading...</div>}>
              <Map
                polylineData={this.state.polylineData}
                heidIcon={20}
                style={{ maxHeight: "300px" }}
                marker={this.state.markers}
                visible={true}
                type={"polylineDrawer"}
                data={this.state.polylineData}
                dataDrawer={this.state.dataDrawer}
                zoom={3}
                showDrawerInfo={false}
              />
            </Suspense>
          ),
        });
      },
    );
  };

  backres = (backResponse) => {
    this.setState({
      data: backResponse,
      dataAux: backResponse,
      dataOut: backResponse,
    });
  };
  resetAdvance = () => {
    let { advancedSearch2 } = this.state;
    advancedSearch2.forEach((advData) => {
      advData.values = [];
    });
    this.setState({ advancedSearch2 }, () => {
      this.findAdvanced();
      this.generateFilters();
      this.generateFiltersDispach();
    });
  };

  generateFilters = (newCat) => {
    const { advancedSearch2, catalogCombo } = this.state;
    let Inputs = advancedSearch2.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                        moment.utc(new Date(e.values[0].init)),
                        moment.utc(new Date(e.values[0].end)),
                      ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              selection
              floating
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
      return null;
    });
    let NewInput = (
      <div>
        <div className="d-flex justify-content-end">
          <Button
            className="mr-3"
            onClick={this.findAdvanced}
            color="primary"
            style={{ width: "auto" }}
            title={this.props.t("apply_filter")}
          >
            {this.props.t("apply")}
          </Button>
          <em
            class="fa-2x mr-2 fas fa-eraser"
            style={{
              color: "#085fb0",

              cursor: "pointer",
            }}
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>

        <div className="row">{Inputs}</div>
      </div>
    );

    this.setState({
      filtros: NewInput,
    });
  };

  generateFiltersDispach = (newCat) => {
    const { advancedSearchDispach, catalogCombo } = this.state;
    let Inputs = advancedSearchDispach.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                        moment.utc(new Date(e.values[0].init)),
                        moment.utc(new Date(e.values[0].end)),
                      ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              selection
              floating
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
      return null;
    });
    let NewInput = (
      <div>
        <div className="d-flex justify-content-end">
          <Button
            className="mr-3"
            onClick={this.findAdvanced}
            color="primary"
            style={{ width: "auto" }}
            title={this.props.t("apply_filter")}
          >
            {this.props.t("apply")}
          </Button>
          <em
            class="fa-2x mr-2 fas fa-eraser"
            style={{
              color: "#085fb0",

              cursor: "pointer",
            }}
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>

        <div className="row">{Inputs}</div>
      </div>
    );

    this.setState({
      filtrosDispach: NewInput,
    });
  };

  handleChangeSelectMultiple = (id, value) => {
    let { advancedSearch2 } = this.state;
    for (let i = 0; i < advancedSearch2.length; i++) {
      const e = advancedSearch2[i];
      if (e.id === id) {
        e.values = value;
      }
    }

    this.setState({ advancedSearch2 }, () => {
      this.generateFilters();
      this.generateFiltersDispach();
      // this.findAdvanced();
    });
  };

  handleChangeDatePicKer = (name) => (event) => {
    let { advancedSearch2 } = this.state;

    try {
      if (event) {
        advancedSearch2.forEach((search) => {
          if (search.id === name) {
            search.values = [
              {
                init: event[0].format("YYYY-MM-DD"),
                end: event[1].format("YYYY-MM-DD"),
              },
            ];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.generateFiltersDispach();
          // this.findAdvanced();
        });
      } else {
        advancedSearch2.forEach((search) => {
          if (search.id === name) {
            search.values = [];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.generateFiltersDispach();
          // this.findAdvanced();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  loadTab = (evt) => {};

  render() {
    let { rolId, userId } = this.state;

    return (
      <ContentWrapper>
        <div className="content-heading">
          <legend className="legendBasic">
            {/* <img
              style={{ margin: "-6px 6px 1px" }}
              alt=""
              src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg"
              height="28"
              width="28"
            ></img> */}
            <i
              className="icon-warehouse-solid-2"
              style={{ marginRight: "5px" }}
            ></i>
            {`${"  " + this.props.t("in_transit")}`}
          </legend>
        </div>

        {/* <Col lg={12} md={12}> */}
        {this.state.map}

        <br></br>

        <Receive _rolId={rolId} _user={userId} />

        {/* </Col> */}
      </ContentWrapper>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(InTransit)),
);
